import {
    ACTION_TO_ADD_POST,
    ADD_FEED_POST,
    CONFIRM,
    FORUM_ADD_CONTEST,
    FORUM_ADD_QUESTION,
    FORUM_ADD_TESTING,
    FORUM_POST_ADMINCLUB_MENU,
    FORUM_REPORTED_POSTS,
    FORUM_TOPIC_DELETE,
    FORUM_TOPIC_EDIT,
    SEO_DESCRIPTION_FORUM_topic,
    SEO_TITLE_FORUM,
    TO_action_YOU_HAVE_TO_BE_loggedIn,
    TO_BE_LOGGED_IN,
} from 'mk/autogenerated/translations/TopicPage.baa280b1f831648a572f0cb7a96128ae'
import { linebreaksbr } from 'mk/bazaar/common/filters';
import { isAuthenticated, isAuthenticatedAs } from 'mk/bazaar/common/userUtils';
import { adminclub_forum_topic_url } from 'mk/urls/functions';
import { analyticsStoreEvent } from 'mk2/actions';
import LeftMenu from 'mk2/apps/blogs/components/LeftMenu';
import { counsellingsPostDetailUrl, counsellingsTopicUrl } from 'mk2/apps/counsellings/urls';
import { DateRange1, KeywordFilterType } from 'mk2/apps/dash/containers/SeoPerformance/FilterForm';
import { dashSeoPerformaceUrl } from 'mk2/apps/dash/urls';
import { addCounsellingQuestion } from 'mk2/apps/forum/actions';
import {
    TOPIC_COVER_MENU_MORE,
    TOPIC_COVER_UPLOAD_FORM_NAME,
    TopicCoverFormData,
} from 'mk2/apps/forum/components/TopicCoverForm';
import { CONTESTS_TOPIC_ID, COUNSELLING_CATEGORY_ID, TESTINGS_TOPIC_ID } from 'mk2/apps/forum/constants';
import Topic from 'mk2/apps/forum/containers/Topic/Topic';
import {
    forumDeleteTopic,
    topicCoverRemoveTrigger,
    topicCoverSubmitTrigger,
    topicCoverUploadTrigger,
    topicFetchTrigger,
    topicSetAsFavoriteTrigger,
    topicSubscribeTrigger,
    topicUnsubscribeTrigger,
} from 'mk2/apps/forum/containers/Topic/Topic.actions';
import { TOPIC_MENU_MORE } from 'mk2/apps/forum/containers/Topic/Topic.constants';
import reducer, { TopicState } from 'mk2/apps/forum/containers/Topic/Topic.reducers';
import saga from 'mk2/apps/forum/containers/Topic/Topic.sagas';
import { getTopicPostsState, getTopicState } from 'mk2/apps/forum/containers/Topic/Topic.selectors';
import { topicUrl } from 'mk2/apps/forum/helpers';
import { getForumComplaintsStatisticsForTopic } from 'mk2/apps/forum/reducers';
import {
    BrandDaysCampaignEntity,
    BrandDaysCampaignSchema,
    ComplaintsStatisticsPerPost,
    CounsellingEntity,
    CounsellingSchema,
    PostEntity,
    PostSchema,
    TopicEntity,
    TopicSchema,
} from 'mk2/apps/forum/schemas';
import { breadcrumbsForum, topicOG } from 'mk2/apps/forum/structuredData';
import {
    forumContestNewUrl,
    forumPostDetailUrl,
    forumPostNewInCategoryUrl,
    forumPostNewInTopicUrl,
    forumPostNewUrl,
    forumReportedUrl,
    forumTestingNewUrl,
    forumTopicEditUrl,
    forumTopicUrl,
    forumUrl,
} from 'mk2/apps/forum/urls';
import { hasMergedForumAndGroups } from 'mk2/apps/forum/utils';
import { loginUrl } from 'mk2/apps/users/urls';
import Btn, { BtnLayout, BtnType } from 'mk2/components/Btn';
import SubmitButton from 'mk2/components/forms/SubmitButton';
import Interpolate from 'mk2/components/Interpolate';
import MenuItem from 'mk2/components/menu/MenuItem';
import { FormPageType } from 'mk2/constants';
import { AppName } from 'mk2/containers/Application/Application';
import Menu from 'mk2/containers/Menu/Menu';
import { menuToggle } from 'mk2/containers/Menu/Menu.actions';
import { PhotosUploadConfig } from 'mk2/containers/PhotosUpload/PhotosUpload';
import { cacheLast } from 'mk2/helpers/cache';
import { mkReduxFormMapDispatchToProps, mkReduxFormMapStateToProps } from 'mk2/helpers/form';
import { showWarningToastAction } from 'mk2/helpers/toasts';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import { url } from 'mk2/helpers/urls';
import FormPage, { FormPageDispatchProps, FormPageStateProps } from 'mk2/pages/FormPage';
import { BrandingProps, HalfpageProps, RightContentSide } from 'mk2/pages/Page';
import {
    AppState,
    getRequestBaseUrl,
    getRequestDeviceMobile,
    getRequestPermissions,
    getRequestUser,
} from 'mk2/reducers';
import { LoadingState } from 'mk2/reducers/loadingState';
import { UserEntity } from 'mk2/schemas';
import { findDenormalizedEntityBySlug, getDenormalizedEntities, getDenormalizedEntity } from 'mk2/selectors';
import { interpolate } from 'mk2/services/i18n';
import { Store } from 'mk2/store/configureStore';
import { parse } from 'query-string';
import React from 'react';
import { MapStateToPropsParam } from 'react-redux';
import { RouteComponentProps, StaticContext } from 'react-router';
import styles from './TopicPage.mscss';

// aby sme vedeli rozlisit medzi poradnami a forum uz pocas LoadingState.INIT a LoadingState.LOADING
// a zobrazovali tak spravne UI
export enum TopicViewType {
    Forum,
    AskAnExpert,
}

export interface OwnProps {}

export interface StateProps extends FormPageStateProps {
    after: number;
    viewType: TopicViewType;
    hashtags: string[];
    topic: TopicEntity;
    posts: PostEntity[];
    hasNext: number;
    hasPrevious: number;
    isSubscribed: boolean;
    isFavorite: boolean;
    mobile: boolean;
    requestUser: UserEntity;
    loadingState: LoadingState;
    errorMessage: string;
    brandDaysCampaign: BrandDaysCampaignEntity;
    brandDaysCampaignGreetingText: string;
    counselling: CounsellingEntity;
    counsellingPostsCount: number;
    baseUrl: string;
    permissions: string[];
    complaintsStatistics: ComplaintsStatisticsPerPost;
    subscribers: number;
}

export interface DispatchProps extends FormPageDispatchProps {
    onLoad(slug: string, hashtags?: string[], after?: number);

    onSubscribe(slug: string, username: string);
    onUnsubscribe(slug: string, username: string);
    onAddToFavorites(topicId: number, userId: number);
    onRemoveFromFavorites(topicId: number, userId: number);

    // From Header - rewrite!
    onTopicDelete(slug: string);
    onStoreEvent(name: string, props: any);
    onUploadFiles(slug: string, config: PhotosUploadConfig, files: File[]);
    onTopicToggleMenuMore();
    onTopicCoverToggleMenuMore();
    onTopicCoverRemove(topicId: number);
    onTopicCoverSave(values: TopicCoverFormData, topicId: number);
    onShowWarningToast(message: string | React.ReactNode);
    onAddCounsellingQuestion(counselling: CounsellingEntity);

    onRead?(topicId: number);
}

interface StaticContextWithUrl extends StaticContext {
    url: string;
}

export type RouteProps = RouteComponentProps<{
    topicSlug: string;
}, StaticContextWithUrl>;

export type Props = OwnProps & StateProps & DispatchProps & RouteProps;

export default class TopicPage extends FormPage<OwnProps & RouteProps, StateProps, DispatchProps> {

    private onAddPostClicked = cacheLast();
    private onDeleteCache = cacheLast();

    public mapStateToProps(): MapStateToPropsParam<StateProps, OwnProps & RouteProps, AppState> {
        return (state: AppState, ownProps: OwnProps & RouteProps): StateProps => {
            const slug = ownProps.match.params.topicSlug;

            const parsed = parse(ownProps.location.search);
            const after = parsed.after;

            const hashtags = parsed.h ? parsed.h.split(',') : [];

            const topicState: TopicState = getTopicState(state, slug);
            const topicPostsState = getTopicPostsState(state, slug, hashtags);

            const posts = getDenormalizedEntities<PostEntity>(state, PostSchema, topicPostsState.ids);
            const topic = findDenormalizedEntityBySlug<TopicEntity>(state, TopicSchema, slug);

            return {
                ...mkReduxFormMapStateToProps(TOPIC_COVER_UPLOAD_FORM_NAME)(state),
                viewType: TopicViewType.Forum,
                after,
                hashtags,
                topic,
                posts,
                hasNext: topicPostsState.hasNext,
                hasPrevious: topicPostsState.hasPrevious,
                isSubscribed: topicState.isSubscribed,
                isFavorite: topicState.isFavorite,
                loadingState: topicPostsState.loadingState,
                errorMessage: topicPostsState.errorMessage,
                brandDaysCampaign: getDenormalizedEntity<BrandDaysCampaignEntity>(state, BrandDaysCampaignSchema, topicState.brandDaysCampaignId),
                brandDaysCampaignGreetingText: topicState.brandDaysCampaignGreetingText,
                counselling: getDenormalizedEntity<CounsellingEntity>(state, CounsellingSchema, topicState.counsellingId),
                counsellingPostsCount: topicState.counsellingPostsCount,
                mobile: getRequestDeviceMobile(state),
                requestUser: getRequestUser(state),
                baseUrl: getRequestBaseUrl(state),
                permissions: getRequestPermissions(state),
                // Topic can be null when we are loading data
                complaintsStatistics: topic ? getForumComplaintsStatisticsForTopic(state, topic.id) : {},
                subscribers: topicState.subscribers,
            };
        };
    }

    public mapDispatchToProps(): MapDispatchToPropsObject<DispatchProps> {
        return {
            ...mkReduxFormMapDispatchToProps(TOPIC_COVER_UPLOAD_FORM_NAME),
            onLoad: topicFetchTrigger,
            onSubscribe: topicSubscribeTrigger,
            onUnsubscribe: topicUnsubscribeTrigger,
            onAddToFavorites: (topicId, userId) => topicSetAsFavoriteTrigger(topicId, userId, true),
            onRemoveFromFavorites: (topicId, userId) => topicSetAsFavoriteTrigger(topicId, userId, false),
            onUploadFiles: topicCoverUploadTrigger,
            onTopicDelete: forumDeleteTopic,
            onTopicToggleMenuMore: () => menuToggle(TOPIC_MENU_MORE),
            onTopicCoverToggleMenuMore: () => menuToggle(TOPIC_COVER_MENU_MORE),
            onTopicCoverSave: (values: TopicCoverFormData, topicId: number) => topicCoverSubmitTrigger(values, topicId),
            onTopicCoverRemove: topicCoverRemoveTrigger,
            onStoreEvent: analyticsStoreEvent,
            onShowWarningToast: showWarningToastAction,
            onAddCounsellingQuestion: addCounsellingQuestion,
        };
    }

    public getMetaTitle(props: Props): string {
        const { topic } = props;
        return topic ? topic.name : SEO_TITLE_FORUM;
    }

    public getMetaDescription(props: Props): string {
        const { topic, brandDaysCampaignGreetingText } = props;

        // FIXME caka na json-markdown aby sme ako description poslali iba plaintext
        if (brandDaysCampaignGreetingText) {
            return brandDaysCampaignGreetingText;
        } else if (topic) {
            return topic.description || interpolate(SEO_DESCRIPTION_FORUM_topic, { topic: topic.name });
        } else {
            return null;
        }
    }

    public getOpenGraphData(props: Props, baseUrl: string, currentUrl: string): {[key: string]: string} {
        const { topic } = props;

        if (topic) {
            return {
                ...super.getOpenGraphData(props, baseUrl, currentUrl),
                ...topicOG(baseUrl, topic),
            };
        }
    }

    public getStructuredData(props: Props): object[] {
        const { topic, baseUrl } = props;

        if (topic) {
            return [breadcrumbsForum(baseUrl, null, topic)];
        }
    }

    public getCanonicalUrl(baseUrl: string, props: Props): string {
        const { match: { params: { topicSlug } } } = props;
        return baseUrl + url(forumTopicUrl, { topicSlug });
    }

    public render(props: Props): false | JSX.Element {
        const { staticContext, match, topic, history } = props;
        if (topic) {
            // Redirects between /ask-an-expert/ and /forum/
            if (topic.category.id === COUNSELLING_CATEGORY_ID && match.path !== counsellingsTopicUrl) {
                if (staticContext) {
                    staticContext.statusCode = 301;
                    staticContext.url = url(counsellingsTopicUrl, match.params);
                } else {
                    // history.replace(url(counsellingsTopicUrl, match.params));
                }
            } else if (topic.category.id !== COUNSELLING_CATEGORY_ID && match.path !== forumTopicUrl) {
                if (staticContext) {
                    staticContext.statusCode = 301;
                    staticContext.url = url(forumTopicUrl, match.params);
                } else {
                    // history.replace(url(forumTopicUrl, match.params));
                }
            }
        }

        return (
            <Topic {...props} />
        );
    }

    public renderRight(props: Props): JSX.Element {
        const { location } = props;
        return (this.hasMergedForumAndGroups(props)) ? (
            <LeftMenu location={location} />
        ) : null;
    }

    public getRightContentSide(app: AppName, props: Props): RightContentSide {
        return this.hasMergedForumAndGroups(props) ? RightContentSide.LeftSide : RightContentSide.RightSide;
    }

    public hasHeaderBackButton(props: Props): boolean {
        return true;
    }

    public getDefaultBackPath(props: Props): string {
        return forumUrl;
    }

    public getHalfpageProps(props: Props): HalfpageProps {
        const { topic } = props;
        if (topic && topic.isCommercial) {
            return null;
        }

        return {
            zone: 'Forum Category - Halfpage Sticky (Desktop)',
        };
    }

    public getBrandingProps(props: Props): BrandingProps {
        const { topic } = props;
        if (!topic) {
            return {
                zone: 'Forum - Branding',
            };
        }

        if (topic.isBrandDays) {
            return {
                zone: 'Forum - Branding Dni s',
                targeting: { mk_dni_s: topic.slug.substr(0, 40) },
            };
        } else if (topic.isCommercial) {
            return null;
        } else {
            return {
                zone: 'Forum - Branding',
            };
        }
    }

    public getHeaderLeft(props: Props): React.ReactNode {
        const { currentFormPage, onCancelFormPage } = props;
        if (currentFormPage === FormPageType.ChangeTopicCover) {
            return (
                <Btn
                    layout={BtnLayout.Icon}
                    onClick={onCancelFormPage}
                    icon="fa-times"
                />
            );
        } else {
            return super.getHeaderLeft(props);
        }
    }

    public getHeaderRight(props: Props): React.ReactNode {
        const {
            requestUser, permissions, topic, complaintsStatistics, location: { pathname },
            onTopicToggleMenuMore, onTopicDelete, onStoreEvent, counselling,
            currentFormPage, onShowWarningToast, onAddCounsellingQuestion, viewType,
        } = props;

        const isDeleted = topic && topic.deletedAt;
        if (isDeleted) {
            return null;
        }

        const isModerator = topic && isAuthenticatedAs(requestUser, topic.moderators);
        const isAdmin = permissions.indexOf('forum.can_manage_forum') >= 0;

        const isChangeTopicCoverFormPage = currentFormPage === FormPageType.ChangeTopicCover;
        const isAskAnExpert = viewType === TopicViewType.AskAnExpert;

        const onAddPostClickedHandler = (event) => {
            onStoreEvent('add_thread_clicked', { slug: pathname, category: null });
            if (requestUser && !isAuthenticated(requestUser)) {
                event.preventDefault();
                onShowWarningToast(
                    <Interpolate
                        i18nKey={TO_action_YOU_HAVE_TO_BE_loggedIn}
                        action={ACTION_TO_ADD_POST}
                        loggedIn={(
                            <a href={url(loginUrl, {},  {next: location.pathname})}>{TO_BE_LOGGED_IN}</a>
                        )}
                    />,
                );
            } else if (counselling && counselling.isLocked) {
                event.preventDefault();
                onShowWarningToast(linebreaksbr(counselling.lockedMessage));
            }
        };

        let addBtn;
        if (isChangeTopicCoverFormPage) {
            addBtn = isAdmin ? (
                <SubmitButton
                    key="btn"
                    label={CONFIRM}
                    formName={TOPIC_COVER_UPLOAD_FORM_NAME}
                />
            ) : null;
        } else if (isAskAnExpert) {
            if (counselling) {
                addBtn = (
                    <Btn
                        key="btn"
                        type={BtnType.Blue}
                        label={FORUM_ADD_QUESTION}
                        onClick={this.onAddPostClicked(() => {
                            onAddCounsellingQuestion(counselling);
                        }, `${counselling.id}`)}
                    />
                );
            }
        } else {
            if (!topic) {
                addBtn = (
                    <Btn
                        key="btn"
                        type={BtnType.Blue}
                        label={ADD_FEED_POST}
                        icon="fa-plus-circle fa-lg"
                        link={isAuthenticated(requestUser) ? forumPostNewUrl : null}
                        onClick={this.onAddPostClicked(onAddPostClickedHandler, pathname, requestUser.id)}
                    />
                );
            } else if (topic.id === CONTESTS_TOPIC_ID) {
                addBtn = isAdmin ? (
                    <Btn
                        key="btn"
                        type={BtnType.AdminOutline}
                        label={FORUM_ADD_CONTEST}
                        icon="fa-plus-circle fa-lg"
                        link={url(forumContestNewUrl, { topicSlug: topic.slug })}
                        onClick={this.onAddPostClicked(onAddPostClickedHandler, pathname, requestUser.id)}
                    />
                ) : null;
            } else if (topic.id === TESTINGS_TOPIC_ID) {
                addBtn = isAdmin ? (
                    <Btn
                        key="btn"
                        type={BtnType.AdminOutline}
                        label={FORUM_ADD_TESTING}
                        icon="fa-plus-circle fa-lg"
                        link={url(forumTestingNewUrl, { topicSlug: topic.slug })}
                        onClick={this.onAddPostClicked(onAddPostClickedHandler, pathname, requestUser.id)}
                    />
                ) : null;
            } else {
                addBtn = (
                    <Btn
                        key="btn"
                        type={BtnType.Blue}
                        label={ADD_FEED_POST}
                        icon="fa-plus-circle fa-lg"
                        link={
                            isAuthenticated(requestUser) ? (
                            topic.category && topic.category.slug && topic.slug
                                ? url(forumPostNewInTopicUrl, { categorySlug: topic.category.slug, topicSlug: topic.slug })
                                : url(forumPostNewInCategoryUrl, { categorySlug: topic.category.slug })
                            ) : null
                        }
                        onClick={this.onAddPostClicked(onAddPostClickedHandler, pathname, requestUser.id)}
                    />
                );
            }
        }

        const hasComplaints = (isModerator || isAdmin) && Object.keys(complaintsStatistics).some((k) => complaintsStatistics[k].count > 0);
        const hasEdit = (isModerator || isAdmin) && !!topic;
        const hasDelete = isAdmin && topic && topic.id !== CONTESTS_TOPIC_ID && topic.id !== TESTINGS_TOPIC_ID;
        const hasAdminclub = topic && isAdmin;
        const hasSeoStats = topic && permissions.indexOf('dash.can_manage_seo') >= 0;
        let menu;
        if ((hasComplaints || hasEdit || hasDelete || hasAdminclub || hasSeoStats) && !isChangeTopicCoverFormPage) {
            const role = isAdmin ? 'admin' : (isModerator ? 'moderator' : '');
            menu = (
                <Menu
                    key="menu"
                    menuId={TOPIC_MENU_MORE}
                    trigger={
                        <Btn
                            type={BtnType.BlueOutline}
                            icon="fa-cog fa-lg"
                            onClick={onTopicToggleMenuMore}
                            bullet={hasComplaints}
                            bulletClassName={styles.TopicPage__menu__trigger__bullet}
                        />
                    }
                >
                    {hasComplaints && (
                        <MenuItem
                            label={FORUM_REPORTED_POSTS}
                            icon="fa-exclamation-triangle"
                            className={styles[`TopicPage__menu__item--${role}`]}
                            link={url(forumReportedUrl, {topicSlug: topic.slug})}
                            isAdminUI={!isModerator && isAdmin}
                        />
                    )}
                    {hasEdit && (
                        <MenuItem
                            label={FORUM_TOPIC_EDIT}
                            icon="fa-pencil"
                            link={url(forumTopicEditUrl, {topicId: topic.id})}
                            isAdminUI={!isModerator && isAdmin}
                        />
                    )}
                    {hasDelete && (
                        <MenuItem
                            label={FORUM_TOPIC_DELETE}
                            icon="fa-trash"
                            onClick={this.onDeleteCache(() => {
                            onTopicDelete(topic.slug);
                        }, topic.slug)}
                            isAdminUI
                        />
                    )}
                    {hasAdminclub && (
                        <MenuItem
                            label={FORUM_POST_ADMINCLUB_MENU}
                            icon="fa-life-ring"
                            link={adminclub_forum_topic_url(topic.id)}
                            asAnchor
                            isAdminUI
                        />
                    )}
                    {hasSeoStats && (
                        <MenuItem
                            label="SEO traffic"
                            icon="fa-line-chart"
                            link={
                                url(dashSeoPerformaceUrl, {}, {
                                    range1: DateRange1[DateRange1.Past12Weeks],
                                    urls: (topic.category.id === COUNSELLING_CATEGORY_ID
                                        ? [ topicUrl(topic),
                                            '^' + url(counsellingsPostDetailUrl, {topicSlug: topic.slug, postSlug: 'xxx'}).replace(/xxx.*/, ''),
                                            // legacy urls, pred presunom na /ask-an-expert/*
                                            url(forumTopicUrl, {topicSlug: topic.slug}),
                                            '^' + url(forumPostDetailUrl, {topicSlug: topic.slug, postSlug: 'xxx'}).replace(/xxx.*/, ''),
                                        ] : [
                                            topicUrl(topic),
                                            '^' + url(forumPostDetailUrl, {topicSlug: topic.slug, postSlug: 'xxx'}).replace(/xxx.*/, ''),
                                        ]
                                    ).join('\n'),
                                    keywords: KeywordFilterType[KeywordFilterType.NonBranded],
                                })}
                            asAnchor
                            linkTarget="_blank"
                            isAdminUI
                        />
                    )}
                </Menu>
            );
        }
        return [menu, '\u00A0\u00A0', addBtn];
    }

    public getSubmitButton(props: Props): React.ReactNode {
        return null;
    }

    public hasMergedForumAndGroups(props: Props): boolean {
        return hasMergedForumAndGroups(props.requestUser);
    }

    public registerInStore(store: Store<AppState>) {
        store.injectReducer('containers.forum.forumTopic', reducer);
        store.injectSaga('containers.forum.forumTopic', saga);
    }

}
